import React, { useState } from "react";
import { Container, Stack, Typography, Grid } from "@mui/material";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import moment from "moment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ReactReadMoreReadLess from "react-read-more-read-less";

const FeedRequestCard = ({
  title,
  location,
  fromDate,
  urgent,
  details,
  id,
  clickHandler,
}) => {
  const [showFullDescription, setFullDescription] = useState(false);
  const date = moment(fromDate).utc().format("MMMM Do, YYYY");
  const showFullDescriptionHandler = () => {
    setFullDescription(!showFullDescription);
  };
  const description = showFullDescription ? details : details.slice(0, 85);
  return (
    <Grid
      container
      style={{
        borderBottom: "1px solid #EEEBEF",
        marginTop: "20px",
        paddingBottom: "20px",
        cursor: "pointer",
      }}
      // alignItems="center"
      onClick={() => clickHandler(id)}
    >
      <Grid item sm={1}></Grid>
      <Grid item sm={2}>
        <AccountCircleIcon
          style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
        />
      </Grid>
      <Grid item sm={8}>
        <Typography style={{ fontWeight: "bold" }} className="mb-10">
          {title}
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack
            spacing={1}
            direction="row"
            alignItems="center"
            style={{ color: "#7A7A80" }}
          >
            <FmdGoodOutlinedIcon />
            <Typography variant="body1">{location}</Typography>
          </Stack>
          {urgent == true ? (
            <div
              style={{
                background: "rgba(255, 0, 32, 0.1)",
                border: "1px solid #EB4335",
                borderRadius: "100px",
                padding: "4px 8px",
                color: "rgba(235, 67, 53, 1)",
              }}
            >
              Urgent
            </div>
          ) : (
            <Stack
              spacing={1}
              direction="row"
              alignItems="center"
              style={{ color: "#7A7A80" }}
            >
              <CalendarTodayOutlinedIcon />
              <Typography variant="body1">{date}</Typography>
            </Stack>
          )}
        </Stack>
        <Typography style={{ color: "#7A7A80" }} className="mt-5 mb-10">
          {description}{" "}
          {details.length > 85 && !showFullDescription ? "... " : " "}
          {details.length > 85 ? (
            <span
              style={{ color: "#0741c4" }}
              onClick={showFullDescriptionHandler}
            >
              Read {showFullDescription ? "Less" : "More"}
            </span>
          ) : (
            <></>
          )}
        </Typography>

        {/* <ReactReadMoreReadLess
          className="mt-5 mb-10"
          charLimit={200}
          readMoreText={"Read more"}
          readLessText={"Read less"}
          readMoreStyle={{ color: "#0741c4" }}
          readLessStyle={{ color: "#0741c4" }}
        >
          {details}
        </ReactReadMoreReadLess> */}
        <span
          style={{
            background: "rgba(52, 168, 83, 0.1)",
            border: "1px solid #55BE64",
            borderRadius: "100px",
            padding: "4px 8px",
            color: "rgba(85, 190, 100, 1)",
            width: "30px",
          }}
        >
          Open
        </span>
      </Grid>
    </Grid>
  );
};

export default FeedRequestCard;
